import { h } from 'preact'
import { useState, useEffect } from 'preact/hooks'
import { updateCSSVarScrollbarWidth, tagParser, safeHtml } from '../../js/modules/utilities'
import { attributesAnalytics } from '../../js/modules/component'

export const MessageConnexion = ({ CTA, cacheKey }) => {
   const [isClosed, setisClosed] = useState(document.cookie.search('messageConnexionClosed') !== -1 ? true : false)

   const closeBanner = (e) => {
      e.preventDefault()
      setisClosed(true)
      document.cookie = 'messageConnexionClosed=1;'
   }

   useEffect(() => {
      updateCSSVarScrollbarWidth()
   }, [])

   return isClosed ? null : (
      <div class="position-relative">
         <a
            href={CTA.URL}
            id="message-connexion"
            class="message-connexion"
            {...attributesAnalytics(CTA.analytics)}
            data-testid="message-connexion"
            data-cache-key={cacheKey}
         >
            <div class="site-width alert-container alert-info">
               <div class="container-fluid">
                  <p class="alert">
                     <svg class="icone-first" width="26" height="28" aria-hidden="true" viewBox="0 0 32 32">
                        <path d="M7.23 14.92c-0.003 0-0.006 0-0.010 0-1.977 0-3.58-1.603-3.58-3.58 0 0 0 0 0-0v0c0 0.006 0 0.013 0 0.021 0 1.977-1.603 3.58-3.58 3.58-0.021 0-0.042-0-0.063-0.001l0.003 0c1.983 0 3.59 1.607 3.59 3.59v0c0.028-1.956 1.62-3.53 3.58-3.53 0.018 0 0.035 0 0.053 0l-0.003-0zM27.9 13.4v0c0 0.003 0 0.007 0 0.010 0 2.266-1.834 4.104-4.099 4.11h-0.001c0 0 0 0 0 0 2.27 0 4.11 1.84 4.11 4.11 0 0.004 0 0.007 0 0.011v-0.001h0.050c0.005-2.239 1.805-4.056 4.037-4.090l0.003-0c-0.006 0-0.013 0-0.021 0-2.253 0-4.080-1.827-4.080-4.080 0-0.025 0-0.049 0.001-0.074l-0 0.004zM22.68 27.4c-1.984 0.006-3.59 1.615-3.59 3.6 0 0 0 0 0 0v0c0-0.003 0-0.006 0-0.010 0-1.983-1.607-3.59-3.59-3.59 0 0 0 0 0 0v0c1.984-0.006 3.59-1.615 3.59-3.6 0 0 0 0 0-0v0c0 0.003 0 0.006 0 0.010 0 1.983 1.607 3.59 3.59 3.59 0 0 0 0 0 0v0zM23.68 22.4c-0.284-2.053-1.5-3.773-3.198-4.743l-0.032-0.017c-1.302 1.232-3.061 1.992-4.998 2h-0.002c-0.002 0-0.005 0-0.008 0-1.937 0-3.697-0.762-4.995-2.003l0.003 0.003c-1.966 1.083-3.279 3.137-3.29 5.498v0.002c0 2 0 4 0 6-0.007 0.072-0.011 0.155-0.011 0.24s0.004 0.168 0.012 0.25l-0.001-0.011c0.289 1.379 1.495 2.401 2.939 2.401 0.021 0 0.043-0 0.064-0.001l-0.003 0h13.57v-8.78c0-0.017 0-0.038 0-0.058 0-0.276-0.018-0.547-0.054-0.813l0.003 0.031zM24.73 9.28v0c0 0 0 0 0-0 0-1.703 1.378-3.084 3.079-3.090h0.001c0 0 0 0-0 0-1.701 0-3.080-1.379-3.080-3.080 0-0.003 0-0.007 0-0.011v0.001c0 0 0 0 0 0 0 1.703-1.378 3.084-3.079 3.090h-0.001c1.702 0.006 3.080 1.387 3.080 3.090 0 0 0 0 0 0v0zM15.48 17.54c2.85 0 5.16-2.31 5.16-5.16s-2.31-5.16-5.16-5.16c-2.846 0-5.154 2.305-5.16 5.149v0.001c0 0 0 0 0 0 0 2.852 2.309 5.164 5.159 5.17h0.001zM6.1 10.34h0.060c0.028-2.84 2.328-5.133 5.168-5.15h0.002c-2.846-0.006-5.15-2.314-5.15-5.16 0-0.011 0-0.021 0-0.032v0.002h-0.070c0 0.018 0 0.039 0 0.060 0 2.811-2.279 5.090-5.090 5.090-0.007 0-0.014 0-0.021-0h0.001c0 0 0.001 0 0.001 0 2.817 0 5.1 2.283 5.1 5.1 0 0.032-0 0.063-0.001 0.095l0-0.005z"></path>
                     </svg>
                     <span class="alert-info-title" dangerouslySetInnerHTML={{ __html: safeHtml(tagParser(CTA.label)) }} />
                  </p>
               </div>
            </div>
         </a>
         <button type="button" id="closeMessageConnexion" class="closeMessageConnexion btn" onClick={closeBanner} title="Fermer le message" aria-label="Fermer le message">
            <span aria-hidden="true">&times;</span>
         </button>
      </div>
   )
}
